import { GraphicObjectCreator } from "./graphic-object-creator";

export class VisualizatorCreator extends GraphicObjectCreator {
  constructor(canvasCreator, commonSettings) {
    super();
    this.canvasCreator = canvasCreator;
    this.commonSettings = commonSettings;
  }

  create(settings) {
    let calllbackArray = this.callbacks.get("beforeCreate");
    calllbackArray.forEach(callback => callback(settings, this));
    let canvasObject = this.canvasCreator.create(settings.canvas);
    if (this.commonSettings.mode == "debug") {
      let debugSettings = this.commonSettings.modeSettings.get("debug");
      if (debugSettings !== undefined) {
        canvasObject.setDebugMode(debugSettings.settings);
      }
    }
    calllbackArray = this.callbacks.get("afterCreate");
    calllbackArray.forEach(callback => callback(canvasObject, settings, this));
    return canvasObject;
  }
}
